import React from 'react';
import { Home } from 'lucide-react';

export const TeamLogo = ({ program, size = 'w-24 h-24' }) => (
  program.logo ? (
    <img src={program.logo} alt={`${program.title} logo`} className={`${size} object-contain !bg-transparent`} style={{ background: 'transparent' }} data-testid={`team-logo-${program.id}`} />
  ) : (
    <div className={`${size} rounded-full bg-forest/10 text-forest flex items-center justify-center`} data-testid={`team-logo-${program.id}`}>
      <Home size={34} />
    </div>
  )
);
